'use strict';

angular.module('systemOwnerReviewRoutes.ConfirmSystemOwnership', ['systemOwnerReviewControllers.ConfirmSystemOwnership',
                                                                  'services.businessSystem',
                                                                  'services.systemOwnerReview'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('systemOwnerReview.authUser.confirmSystemOwnership', {
            url: '/ConfirmSystemOwnership',
            views: {
                '': {
                    templateUrl: require('./ConfirmSystemOwnership.tpl.html'),
                    controller: 'ConfirmSystemOwnershipController'
                },
                'sidebar@systemOwnerReview.authUser.confirmSystemOwnership': {
                    templateUrl: require('./SideBar.tpl.html'),
                    controller: 'SideBarConfirmOwnershipController',
                    resolve: {
                        allSystemTypes: ['businessSystemService', function (service) {
                            return service.getSystemTypes();
                        }]
                    }
                }
            },
            resolve: {
                systemsToReview: ['$stateParams', 'systemOwnerReviewService', function ($stateParams, service) {
                    return service.getSystemsToReview($stateParams.authLogin);
                }]
            }
        })

        // Explanations
        .state('systemOwnerReview.authUser.confirmSystemOwnershipExplanation', {
            url: '/ConfirmSystemOwnership_Explanation',
            templateUrl: require('./Explanation1.tpl.html'),
            controller: 'ExplanationConfirmSystemOwnershipController'
        })

        .state('systemOwnerReview.authUser.confirmSystemOwnershipExplanationStep2', {
            url: '/ConfirmSystemOwnership_Explanation',
            templateUrl: require('./Explanation2.tpl.html'),
            controller: 'ExplanationConfirmSystemOwnershipController'
        })

        .state('systemOwnerReview.authUser.confirmSystemOwnershipExplanationStep3', {
            url: '/ConfirmSystemOwnership_Explanation',
            templateUrl: require('./Explanation3.tpl.html'),
            controller: 'ExplanationConfirmSystemOwnershipController'
        })

        .state('systemOwnerReview.authUser.confirmSystemOwnershipExplanationStep4', {
            url: '/ConfirmSystemOwnership_Explanation',
            templateUrl: require('./Explanation4.tpl.html'),
            controller: 'ExplanationConfirmSystemOwnershipController'
        })

        .state('systemOwnerReview.authUser.confirmSystemOwnershipExplanationStep5', {
            url: '/ConfirmSystemOwnership_Explanation',
            templateUrl: require('./Explanation5.tpl.html'),
            controller: 'ExplanationConfirmSystemOwnershipController'
        })

        // By System Type
        .state('systemOwnerReview.authUser.confirmSystemOwnership.bySystemType', {
            url: '/{systemTypeSlug}',
            views: {
                'details@systemOwnerReview.authUser.confirmSystemOwnership': {
                    templateUrl: require('./BySystemType.tpl.html'),
                    controller: 'ConfirmOwnershipBySystemTypeController',
                    resolve: {
                        systemType: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                            return service.getSystemTypeBySlug($stateParams.systemTypeSlug);
                        }]
                    }
                }
            }
        });
}]);